import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { CapacitysessionService } from '../../services/capacitysession.service';
import { RegistrationService } from '../../services/registration.service';

@Component({
    templateUrl: './selection.component.html',
    standalone: false
})
export class SelectionComponent implements OnInit {
  isSubmitting = false;
  //programOptionRadios1 =[];
  //programOptionRadios2 =[];
  // wave, name, displayScreen
  waves=[
    [1, "Wave 1", "Wave 1: September 22 - September 25, 2025"],
    [2, "Wave 2", "Wave 2: September 25 - September 28, 2025"]
  ];
  programOptionRadios =[];

  attendee;
  constructor(private navigationService: NavigationService,
    private capacityService: CapacitysessionService,
    private registrationService: RegistrationService
  ) {

    this.getWavesCapacity(); 
    this.attendee = this.registrationService.getAttendee({});

  }

  async getWavesCapacity(){
   for (let index = 0; index < this.waves.length; index++) {
    let el=this.waves[index];
    //            this.capacityService.getCapacity(1, "Wave 1", [1], "Wave 1: September 29 - October 07, 2023",this.programOptionRadios1);
    let p1= await this.capacityService.getCapacity(el[0], el[1], [el[0]], el[2],this.programOptionRadios);
   }
  }

  ngOnInit(): void {}


  forward(form) {
    this.isSubmitting = true;

    if (form.valid){
      if(this.attendee.$mtcCapacitySet){
        this.capacityService.updateCapacity(this.attendee.$mtcWave.capacityName).then(() => {
          this.navigationService.forward();
        });
      }else{
        this.capacityService.insertCapacity(this.attendee.$mtcWave.capacityName).then(() => {
          this.attendee.$mtcCapacitySet = true;
          this.navigationService.forward();
        });
      }
    }else{
      this.isSubmitting = false;
    }
    
  }

  radioChange(event){
    console.log(event.value);
    let waveSelected= this.programOptionRadios.find(el=>el.capacityName===event.value);
    this.attendee.$mtcWave = waveSelected;
    this.attendee.WaveNo = waveSelected.value;

  }

  back() {
    this.navigationService.back();
  }
}
